import { useEffect } from 'react';
import Lenis from '@studio-freight/lenis';

export default function SmoothScroll({ children }) {
    useEffect(() => {
        const lenis = new Lenis({
            /* Tuned to match the reference scroll feel: a short (~0.9s)
               cubic ease-out tail so content glides with a subtle sense
               of momentum but stops close to the wheel — not the mushy
               1.4s expo-out we had before. Nothing else changes: no per-
               element parallax, no scroll-driven scaling — the whole
               document simply smooth-scrolls as one. */
            duration: 0.9,
            easing: (t) => 1 - Math.pow(1 - t, 3),
            smoothWheel: true,
        });
        /* Expose the instance so route-change scroll resets stay in sync
           (see components/ScrollToTop.jsx) — without this, native
           `window.scrollTo(0)` gets overwritten by Lenis's next RAF tick
           and the new page lands mid-scroll. */
        window.__lenis = lenis;
        let raf;
        const loop = (time) => {
            lenis.raf(time);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
            if (window.__lenis === lenis) delete window.__lenis;
        };
    }, []);
    return children;
}
